// src/redux/sagas/timesheetSaga.js
import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../../../api";

import { getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

import {
    SET_TIMESHEET_LOADING,

    FETCH_TIMESHEETS_REQUEST,
    fetchTimesheetsSuccess,
    fetchTimesheetsFail,

    GET_TIMESHEET_REQUEST,
    getTimesheetSuccess,
    getTimesheetFail,

    CREATE_TIMESHEET_REQUEST,
    createTimesheetSuccess,
    createTimesheetFail,

    UPDATE_TIMESHEET_REQUEST,
    updateTimesheetSuccess,
    updateTimesheetFail,

    DELETE_TIMESHEET_REQUEST,
    deleteTimesheetSuccess,
    deleteTimesheetFail,

    FETCH_TIMESHEET_DAYS_REQUEST,
    fetchTimesheetDaysSuccess,
    fetchTimesheetDaysFail,

    UPSERT_TIMESHEET_DAY_REQUEST,
    upsertTimesheetDaySuccess,
    upsertTimesheetDayFail,

    DELETE_TIMESHEET_DAY_REQUEST,
    deleteTimesheetDaySuccess,
    deleteTimesheetDayFail,

    FETCH_TIMESHEET_OVERTIMES_REQUEST,
    fetchTimesheetOvertimesSuccess,
    fetchTimesheetOvertimesFail,

    UPSERT_TIMESHEET_OVERTIME_REQUEST,
    upsertTimesheetOvertimeSuccess,
    upsertTimesheetOvertimeFail,

    DELETE_TIMESHEET_OVERTIME_REQUEST,
    deleteTimesheetOvertimeSuccess,
    deleteTimesheetOvertimeFail,

    // Overtime Workflow
    SUBMIT_OVERTIME_REQUEST,
    submitOvertimeSuccess,
    submitOvertimeFail,

    FETCH_OVERTIME_MANAGER_INBOX_REQUEST,
    fetchOvertimeManagerInboxSuccess,
    fetchOvertimeManagerInboxFail,

    FETCH_OVERTIME_MANAGER_HISTORY_REQUEST,
    fetchOvertimeManagerHistorySuccess,
    fetchOvertimeManagerHistoryFail,

    FETCH_OVERTIME_ADMIN_INBOX_REQUEST,
    fetchOvertimeAdminInboxSuccess,
    fetchOvertimeAdminInboxFail,

    FETCH_OVERTIME_ADMIN_HISTORY_REQUEST,
    fetchOvertimeAdminHistorySuccess,
    fetchOvertimeAdminHistoryFail,

    MANAGER_OVERTIME_DECISION_REQUEST,
    managerOvertimeDecisionSuccess,
    managerOvertimeDecisionFail,

    ADMIN_OVERTIME_DECISION_REQUEST,
    adminOvertimeDecisionSuccess,
    adminOvertimeDecisionFail,

    setTimesheetLoading,
} from "../actions/timesheetActions";

const extractErrorMessage = (error, fallback) => {
    return (
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        fallback
    );
};

// =========================
// TIMESHEETS
// =========================
export function* fetchTimesheetsSaga() {
    const url = `${API_BASE_URL}/api/timesheets`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    yield put(setTimesheetLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchTimesheetsSuccess(resp.data || []));
    } catch (error) {
        yield put(fetchTimesheetsFail(extractErrorMessage(error, "Erreur chargement timesheets")));
    } finally {
        yield put(setTimesheetLoading(false));
    }
}

export function* getTimesheetSaga(action) {
    const id = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/${id}`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    yield put(setTimesheetLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getTimesheetSuccess(resp.data));
    } catch (error) {
        yield put(getTimesheetFail(extractErrorMessage(error, "Erreur chargement timesheet")));
    } finally {
        yield put(setTimesheetLoading(false));
    }
}

export function* createTimesheetSaga(action) {
    const data = action.payload;
    const { onSuccess, onFail, silent } = action.meta || {};
    const url = `${API_BASE_URL}/api/timesheets`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    yield put(setTimesheetLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data, headers: { uid } });
        yield put(createTimesheetSuccess(resp.data));
        if (typeof onSuccess === "function") {
            yield call(onSuccess, resp.data);
        }

        if (!silent) yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Période créée",
            timer: 1200,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur création timesheet");
        yield put(createTimesheetFail(msg));
        if (typeof onFail === "function") {
            yield call(onFail, msg);
        }
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setTimesheetLoading(false));
    }
}

export function* updateTimesheetSaga(action) {
    const { id, payload } = action.payload;
    const data = payload;
    const url = `${API_BASE_URL}/api/timesheets/${id}`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    yield put(setTimesheetLoading(true));
    try {
        const resp = yield call(putRequest, { url, token, data, headers: { uid } });
        yield put(updateTimesheetSuccess(resp.data));
    } catch (error) {
        yield put(updateTimesheetFail(extractErrorMessage(error, "Erreur mise à jour timesheet")));
    } finally {
        yield put(setTimesheetLoading(false));
    }
}

export function* deleteTimesheetSaga(action) {
    const id = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/${id}`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    yield put(setTimesheetLoading(true));
    try {
        yield call(deleteRequest, { url, token, headers: { uid } });
        yield put(deleteTimesheetSuccess(id));
    } catch (error) {
        yield put(deleteTimesheetFail(extractErrorMessage(error, "Erreur suppression timesheet")));
    } finally {
        yield put(setTimesheetLoading(false));
    }
}

// =========================
// DAYS
// =========================
export function* fetchTimesheetDaysSaga(action) {
    const timesheetId = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/${timesheetId}/days`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    yield put(setTimesheetLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchTimesheetDaysSuccess(timesheetId, resp.data || []));
    } catch (error) {
        yield put(fetchTimesheetDaysFail(extractErrorMessage(error, "Erreur chargement jours")));
    } finally {
        yield put(setTimesheetLoading(false));
    }
}

export function* upsertTimesheetDaySaga(action) {
    const data = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/days`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    try {
        const resp = yield call(putRequest, { url, token, data, headers: { uid } });
        yield put(upsertTimesheetDaySuccess(resp.data));
    } catch (error) {
        yield put(upsertTimesheetDayFail(extractErrorMessage(error, "Erreur sauvegarde jour")));
    }
}

export function* deleteTimesheetDaySaga(action) {
    const { dayId, timesheetId } = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/days/${dayId}`;
    const token =  sessionStorage.getItem("token");
    const uid =  sessionStorage.getItem("uid");

    try {
        yield call(deleteRequest, { url, token, headers: { uid } });
        yield put(deleteTimesheetDaySuccess(dayId, timesheetId));
    } catch (error) {
        yield put(deleteTimesheetDayFail(extractErrorMessage(error, "Erreur suppression jour")));
    }
}

// =========================
// OVERTIME (CRUD)
// =========================
export function* fetchTimesheetOvertimesSaga(action) {
    const timesheetId = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/${timesheetId}/overtimes`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setTimesheetLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchTimesheetOvertimesSuccess(timesheetId, resp.data || []));
    } catch (error) {
        yield put(fetchTimesheetOvertimesFail(extractErrorMessage(error, "Erreur chargement heures supplémentaires")));
    } finally {
        yield put(setTimesheetLoading(false));
    }
}

export function* upsertTimesheetOvertimeSaga(action) {
    const data = action.payload;
    const { autoSubmit, onSuccess, onFail } = action.meta || {};
    const url = `${API_BASE_URL}/api/timesheets/overtimes`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const resp = yield call(putRequest, { url, token, data, headers: { uid } });
        let saved = resp.data;
        yield put(upsertTimesheetOvertimeSuccess(saved));
        if (autoSubmit && saved?.id) {
            const submitUrl = `${API_BASE_URL}/api/timesheets/overtimes/${saved.id}/submit`;
            const submitResp = yield call(postRequest, { url: submitUrl, token, data: {}, headers: { uid } });
            saved = submitResp.data;
            yield put(submitOvertimeSuccess(saved, saved?.timesheetId || resp.data.timesheetId));
            yield call([Swal, Swal.fire], {
                icon: "success",
                title: "",
                text: "Heure supplementaire envoyee en validation",
                timer: 1200,
                showConfirmButton: false,
            });
            if (typeof onSuccess === "function") {
                yield call(onSuccess, saved);
            }
            return;
        }
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Heure supplementaire enregistree",
            timer: 1200,
            showConfirmButton: false,
        });
        if (typeof onSuccess === "function") {
            yield call(onSuccess, saved);
        }
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur sauvegarde heure supplementaire");
        yield put(upsertTimesheetOvertimeFail(msg));
        if (typeof onFail === "function") {
            yield call(onFail, msg);
        }
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2200, showConfirmButton: false });
    }
}

export function* deleteTimesheetOvertimeSaga(action) {
    const { overtimeId, timesheetId } = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/overtimes/${overtimeId}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        yield call(deleteRequest, { url, token, headers: { uid } });
        yield put(deleteTimesheetOvertimeSuccess(overtimeId, timesheetId));
    } catch (error) {
        yield put(deleteTimesheetOvertimeFail(extractErrorMessage(error, "Erreur suppression heure supplémentaire")));
    }
}

// =========================
// OVERTIME WORKFLOW
// =========================
export function* submitOvertimeSaga(action) {
    const { overtimeId, timesheetId } = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/overtimes/${overtimeId}/submit`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const resp = yield call(postRequest, { url, token, data: {}, headers: { uid } });
        yield put(submitOvertimeSuccess(resp.data, timesheetId));
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Heure supplémentaire soumise",
            timer: 1200,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur soumission heure supplémentaire");
        yield put(submitOvertimeFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2200, showConfirmButton: false });
    }
}

export function* fetchOvertimeManagerInboxSaga() {
    const url = `${API_BASE_URL}/api/timesheets/overtimes/manager/inbox`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchOvertimeManagerInboxSuccess(resp.data || []));
    } catch (error) {
        yield put(fetchOvertimeManagerInboxFail(extractErrorMessage(error, "Erreur chargement inbox overtime manager")));
    }
}

export function* fetchOvertimeManagerHistorySaga() {
    const url = `${API_BASE_URL}/api/timesheets/overtimes/manager/history`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchOvertimeManagerHistorySuccess(resp.data || []));
    } catch (error) {
        yield put(fetchOvertimeManagerHistoryFail(extractErrorMessage(error, "Erreur chargement historique overtime manager")));
    }
}

export function* fetchOvertimeAdminInboxSaga() {
    const url = `${API_BASE_URL}/api/timesheets/overtimes/admin/inbox`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchOvertimeAdminInboxSuccess(resp.data || []));
    } catch (error) {
        yield put(fetchOvertimeAdminInboxFail(extractErrorMessage(error, "Erreur chargement inbox overtime admin")));
    }
}

export function* fetchOvertimeAdminHistorySaga() {
    const url = `${API_BASE_URL}/api/timesheets/overtimes/admin/history`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchOvertimeAdminHistorySuccess(resp.data || []));
    } catch (error) {
        yield put(fetchOvertimeAdminHistoryFail(extractErrorMessage(error, "Erreur chargement historique overtime admin")));
    }
}

export function* managerOvertimeDecisionSaga(action) {
    const { overtimeId, decision, comment } = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/overtimes/${overtimeId}/manager-decision`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const resp = yield call(postRequest, { url, token, data: { decision, comment }, headers: { uid } });
        yield put(managerOvertimeDecisionSuccess(resp.data));
        // Refresh inbox
        yield put({ type: FETCH_OVERTIME_MANAGER_INBOX_REQUEST });
        yield put({ type: FETCH_OVERTIME_MANAGER_HISTORY_REQUEST });
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: decision ? "Heure supplémentaire approuvée" : "Heure supplémentaire refusée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision overtime");
        yield put(managerOvertimeDecisionFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2200, showConfirmButton: false });
    }
}

export function* adminOvertimeDecisionSaga(action) {
    const { overtimeId, decision, comment } = action.payload;
    const url = `${API_BASE_URL}/api/timesheets/overtimes/${overtimeId}/admin-decision`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const resp = yield call(postRequest, { url, token, data: { decision, comment }, headers: { uid } });
        yield put(adminOvertimeDecisionSuccess(resp.data));
        // Refresh inbox
        yield put({ type: FETCH_OVERTIME_ADMIN_INBOX_REQUEST });
        yield put({ type: FETCH_OVERTIME_ADMIN_HISTORY_REQUEST });
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: decision ? "Heure supplémentaire approuvée" : "Heure supplémentaire refusée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision overtime");
        yield put(adminOvertimeDecisionFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2200, showConfirmButton: false });
    }
}

// =========================
// WATCHER
// =========================
export default function* watchTimesheetSagas() {
    yield takeLatest(FETCH_TIMESHEETS_REQUEST, fetchTimesheetsSaga);
    yield takeLatest(GET_TIMESHEET_REQUEST, getTimesheetSaga);
    yield takeLatest(CREATE_TIMESHEET_REQUEST, createTimesheetSaga);
    yield takeLatest(UPDATE_TIMESHEET_REQUEST, updateTimesheetSaga);
    yield takeLatest(DELETE_TIMESHEET_REQUEST, deleteTimesheetSaga);

    yield takeLatest(FETCH_TIMESHEET_DAYS_REQUEST, fetchTimesheetDaysSaga);
    yield takeEvery(UPSERT_TIMESHEET_DAY_REQUEST, upsertTimesheetDaySaga);
    yield takeLatest(DELETE_TIMESHEET_DAY_REQUEST, deleteTimesheetDaySaga);

    yield takeLatest(FETCH_TIMESHEET_OVERTIMES_REQUEST, fetchTimesheetOvertimesSaga);
    yield takeEvery(UPSERT_TIMESHEET_OVERTIME_REQUEST, upsertTimesheetOvertimeSaga);
    yield takeLatest(DELETE_TIMESHEET_OVERTIME_REQUEST, deleteTimesheetOvertimeSaga);

    // Overtime Workflow
    yield takeEvery(SUBMIT_OVERTIME_REQUEST, submitOvertimeSaga);
    yield takeLatest(FETCH_OVERTIME_MANAGER_INBOX_REQUEST, fetchOvertimeManagerInboxSaga);
    yield takeLatest(FETCH_OVERTIME_MANAGER_HISTORY_REQUEST, fetchOvertimeManagerHistorySaga);
    yield takeLatest(FETCH_OVERTIME_ADMIN_INBOX_REQUEST, fetchOvertimeAdminInboxSaga);
    yield takeLatest(FETCH_OVERTIME_ADMIN_HISTORY_REQUEST, fetchOvertimeAdminHistorySaga);
    yield takeEvery(MANAGER_OVERTIME_DECISION_REQUEST, managerOvertimeDecisionSaga);
    yield takeEvery(ADMIN_OVERTIME_DECISION_REQUEST, adminOvertimeDecisionSaga);
}
